import { DealVersion } from '../../types/deal.types';

export function getPricingDate(deal: DealVersion): string {
  return deal.expectedPricingDate
    ? deal.isWeekOf
      ? `Week of ${deal.expectedPricingDate
          .startOf('week')
          .add(1, 'days')
          .format('MM/DD/YYYY')}`
      : deal.expectedPricingDate.format('MM/DD/YYYY')
    : null;
}
